import React from 'react';

import type { IconProps as IconMoonProps } from 'react-icomoon';
import IcoMoon from 'react-icomoon';

import iconSet from 'assets/svg/selection.json';

import type { IconTypes } from './icon.types';

export interface IconProps extends Omit<IconMoonProps, 'icon'> {
  className?: string;
  icon: IconTypes;
}

const Icon: React.FC<IconProps> = (props) => {
  const defaultSize = 24;
  const iconSize = props.size || defaultSize;

  return (
    <IcoMoon
      iconSet={iconSet}
      size={iconSize}
      {...props}
      style={{ stroke: 'inherit' }}
    />
  );
};

export default Icon;
